import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import appConfig from '../../appConfig';
import { disableRightClick } from '../../utils/uiUtils';

/** @param {{image_name:string}} image name */
function HighlightSetItem({
  hsItem,
  onHighlightClick,
}) {
  let displayItem;
  if (hsItem.previews && hsItem.previews.length > 0) {
    const thumb = hsItem.previews[0];
    const thumbWidth = thumb.width === '0' || !thumb.width ? 260 : thumb.width;
    let thumbHeight = thumb.height === '0' || !thumb.height ? 260 : thumb.height;
    // fix for thumbnails with extreme ratio between height and width
    const thumbRatio = thumbHeight / thumbWidth;
    if (thumbRatio < 0.1) thumbHeight = thumbWidth * 0.5;
    displayItem = (<img
      key={`highlight-thumb__umo-${thumb.umo_id}`}
      alt={thumb.image_name}
      className="image"
      src={`${appConfig.hostURL}${thumb.url}`}
      width={thumbWidth}
      height={thumbHeight}
      onContextMenu={disableRightClick}
    />);
  } else {
    displayItem = (<i
      className={classNames('highlight-set-item__icon')}
      aria-hidden="true"
    />);
  }
  return (
    <div
      className={classNames(
      'highlight-set-item',
      // 'entry-visible', // Hack to stop justifiedGallery from hiding the image on update.
    )}
    >
      <div
        className="highlight-set-item__overlay"
        id={hsItem.i}
        onClick={() => onHighlightClick(hsItem)}
      >
        <div className="highlight-set-item__overlay__text">
          <h2 className="highlight-set-item__overlay__title">{hsItem.n}</h2>
          <p className="highlight-set-item__overlay__items">{hsItem.x} items</p>
        </div>
      </div>
    </div>
  );
}
HighlightSetItem.propTypes = {
  hsItem: PropTypes.instanceOf(Object),
  onHighlightClick: PropTypes.func,
};

export default HighlightSetItem;
